import React from 'react';
import PropTypes from 'prop-types';
import ListItemUL from './ListItemUL';
import DragDropContextComponent from '../DragAndDrop/DragDropContext';

const CardUL = ({
  data, innerCardContent, isDraggable = false, isDragDisabled = false, onDragEnd = () => {},
}) => {
  const draggableItems = data.map((item, index) => (
    <ListItemUL
      key={item.id}
      item={item}
      isDraggable={isDraggable}
      isDragDisabled={isDragDisabled}
      draggableIndex={item.position}
    >
      {innerCardContent(item, index)}
    </ListItemUL>
  ));

  return (
    <div>
      <ul>
        { isDraggable ? (
          <DragDropContextComponent
            draggableItems={draggableItems}
            onDragEnd={(result) => onDragEnd(result)}
          />
        ) : (
          draggableItems
        )}
      </ul>
    </div>
  );
};

CardUL.propTypes = {
  data: PropTypes.array.isRequired,
  innerCardContent: PropTypes.func.isRequired,
  isDraggable: PropTypes.bool,
  isDragDisabled: PropTypes.bool,
  onDragEnd: PropTypes.func,
};

export default CardUL;
